"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebouncedInput = void 0;
var react_1 = __importStar(require("react"));
var DebouncedInput = function (props) {
    var _a = react_1.useState(), debouncedValue = _a[0], setDebouncedValue = _a[1];
    react_1.useEffect(function () {
        if (!debouncedValue || props.value === '') {
            setDebouncedValue(props.value);
        }
    }, [props.value]);
    var timeoutHandle = react_1.useRef();
    return (react_1.default.createElement("input", __assign({}, props, { value: debouncedValue !== null && debouncedValue !== void 0 ? debouncedValue : '', onChange: function (e) {
            var _a;
            setDebouncedValue(e.target.value);
            if (timeoutHandle.current) {
                clearTimeout(timeoutHandle.current);
            }
            timeoutHandle.current = setTimeout(function () {
                props.onChange(e);
            }, (_a = props.debounceTime) !== null && _a !== void 0 ? _a : 200);
        } })));
};
exports.DebouncedInput = DebouncedInput;
//# sourceMappingURL=DebouncedInput.js.map